import { Component, Input } from '@angular/core';
import { RoutedLabel } from '@lockton-apps/shared/interfaces';

@Component({
    selector: 'lui-routed-label',
    styleUrls: ['./routed-label.scss'],
    templateUrl: './routed-label.component.html',
    standalone: false
})
export class RoutedLabelComponent {
  @Input() routedLabel: RoutedLabel[] = [];
}
